import { render, staticRenderFns } from "./SidebarNotificationBox.vue?vue&type=template&id=4f645ab4&scoped=true&"
import script from "./SidebarNotificationBox.vue?vue&type=script&lang=js&"
export * from "./SidebarNotificationBox.vue?vue&type=script&lang=js&"
import style0 from "./SidebarNotificationBox.vue?vue&type=style&index=0&id=4f645ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f645ab4",
  null
  
)

export default component.exports